module.exports = __webpack_public_path__ + "6b36b76aeb79a727fcb8349d4fe253d5.png";


//////////////////
// WEBPACK FOOTER
// ./app/data/images/ScanSnapOCR.png
// module id = 215
// module chunks = 0